const supportedLanguages = ['pl', 'en']

export const selectLanguageBasedOnBrowserLocale = () => {
  const preferredLanguages = navigator.languages || [navigator.language]

  for (let i = 0; i < preferredLanguages.length; i++) {
    const language = preferredLanguages[i].split('-')[0]

    if (supportedLanguages.indexOf(language) > -1) {
      return language
    }
  }

  return 'en'
}
